import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`

html {
  font-size: 10px !important;
}

body, html {
  overscroll-behavior: none;
}

/* to enable native scrolling for browsers which support native scrolling
  ( https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView )
  as well as to allow 'scroll-container' class elements to allow native scrolling (this is useful for 'smooth-scroll-into-view-if-needed' package)
 */
html, .scroll-container {
  overflow-y: scroll;
}

html.modal-open {
  overflow: hidden;
}

body.moda-open {
  overflow: inherit;
}

/* This senses uses's OS's native preferences for scroll, if someone has turned off
  they won't see scroll animation
 */
@media (prefers-reduced-motion) {
  html,
  .scroll-container {
    scroll-behavior: auto;
  }
}

*{
    padding:0;
    margin:0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.headerBox{
  z-index:99;
}

.oh {
  height: 110vh;
  overflow-y: hidden;
  position:fixed;
  width:100%;
  margin:0px auto;
}

body{
    background: #eef4fd !important;
    color: #141823;
    font-size: 1.2rem !important;
    line-height: 1.33 !important;
    font-family: 'Rubik' !important;
    font-weight: 400 !important;
    // font: 400 1.2rem/1.33 'Rubik' !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.giRupee { font-family: 'Rubik'; font-weight: normal;}
.rubik { font-family: 'Rubik'; }
#root{
  font-size: 1.4rem;
}
*,
*:before,
*:after {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0;
  list-style: none;
  padding: 0;
  font-weight: normal;
}
a {
  color: #2276e3;
  text-decoration: none;
  cursor: pointer;
}
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  outline: none;
  border: 0 none;
}
img {
  max-width: 100%;
}

.footerWrap {
  font-weight: 600;
  font-style: normal;
}

/* flex box styles */
.makeFlex {
  display: flex;
  &.column {
    flex-direction: column;
  }
  &.spaceBetween {
    justify-content: space-between;
  }
  &.flexWrap {
    flex-wrap: wrap;
  }
  &.hrtlCenter {
    align-items: center;
  }
  &.vrtlCenter {
    justify-content: center;
  }
  &.perfectCenter {
    align-items: center;
    justify-content: center;
  }
}
.flexOne {
  flex: 1;
}
.noShrink{
  flex-shrink: 0;
}

/* container styles */
.container {
  display: flex;
  flex: 1;
  margin: 0 auto;
  max-width: 1200px;
}
.height100vh {
  height: 100vh;
}

/* when you need margin */
/* Bottom */
.appendBottom2 {
  margin-bottom: 0.2rem;
}
.appendBottom3 {
  margin-bottom: 0.3rem;
}
.appendBottom4 {
  margin-bottom: 0.4rem;
}
.appendBottom8 {
  margin-bottom: 0.8rem;
}
.appendBottom10 {
  margin-bottom: 1rem;
}
.appendBottom12 {
  margin-bottom: 1.2rem;
}
.appendBottom16 {
  margin-bottom: 1.6rem;
}
.appendBottom20 {
  margin-bottom: 2rem;
}
.appendBottom26 {
  margin-bottom: 2.6rem;
}
.appendBottom28 {
  margin-bottom: 2.8rem;
}
.appendBottom32 {
  margin-bottom: 3.2rem;
}
/* Top */
.appendTop2 {
  margin-top: 0.2rem;
}
.appendTop4 {
  margin-top: 0.4rem;
}
.appendTop5 {
  margin-top: 0.5rem;
}
.appendTop8 {
  margin-top: 0.8rem;
}
.appendTop10 {
  margin-top: 1rem;
}
.appendTop12 {
  margin-top: 1.2rem;
}
.appendTop16 {
  margin-top: 1.6rem;
}
.appendTop28 {
  margin-top: 2.8rem;
}
.appendTop32 {
  margin-top: 2.8rem;
}
/* Left */
.appendLeft2 {
  margin-left: 0.2rem;
}
.appendLeft4 {
  margin-left: 0.4rem;
}
.appendLeft5 {
  margin-left: 0.5rem;
}
.appendLeft8 {
  margin-left: 0.8rem;
}
.appendLeft10 {
  margin-left: 1rem;
}
.appendLeft12 {
  margin-left: 1.2rem;
}
.appendLeft16 {
  margin-left: 1.6rem;
}
.appendLeft28 {
  margin-left: 2.8rem;
}
/* Right */
.appendRight2 {
  margin-right: 0.2rem;
}
.appendRight4 {
  margin-right: 0.4rem;
}
.appendRight5 {
  margin-right: 0.5rem;
}
.appendRight8 {
  margin-right: 0.8rem;
}
.appendRight10 {
  margin-right: 1rem;
}
.appendRight12 {
  margin-right: 1.2rem;
}
.appendRight16 {
  margin-right: 1.6rem;
}
.appendRight28 {
  margin-right: 2.8rem;
}

/* Font Colors */
.textBlack {
  color: #000;
}
.textDark {
  color: #141823;
}
.textLightDark {
  color: #4f525a;
}
.textGray {
  color: #898b91;
}
.textBlue {
  color: #2276e3;
}
.textWhite {
  color: #fff;
}
.textGreen {
  color: #2bac36;
}
.textOrange {
  color: #ff713e;
}
.textLightOrange {
  color: #ff9a76;
}

/* Font Size */
.font10 {
  font-size: 1rem;
  line-height: 1.4rem;
}
.font12 {
  font-size: 1.2rem;
  line-height: 1.6rem;
}
.font14 {
  font-size: 1.4rem;
  line-height: 1.8rem;
}
.font14Global {
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: #2276e3;
}
.font16 {
  font-size: 1.6rem;
  line-height: 2rem;
}
.font16Global {
  font-size: 1.6rem;
  line-height: 2rem;
}
.font18 {
  font-size: 1.8rem;
  line-height: 2.4rem;
}
.font20 {
  font-size: 2rem;
  line-height: 2.6rem;
}
.font22 {
  font-size: 2.2rem;
  line-height: 2.8rem;
}
.font24 {
  font-size: 2.4rem;
  line-height: 3rem;
}
.font26 {
  font-size: 2.6rem;
  line-height: 3.2rem;
}
.font28 {
  font-size: 2.8rem;
  line-height: 3.4rem;
}

/* when you need font weight */
.fontRegular {
  font-weight: 400;
}
.fontMedium {
  font-weight: 600;
}

/* when you need text alignment */
.textCenter {
  text-align: center;
}
.textLeft {
  text-align: left;
}
.textRight {
  text-align: right;
}
`;
